import {app} from '@tfx/common/app'
import {Controller} from 'stimulus'
import {APP_HOST, RAILS_ENV} from 'tfx-common/constants.js'
import Http from 'vue-resource/src/http'

export default class extends Controller {
  static values = {
    eventUrl: String,
    context: String
  }

  disconnect() {
    this.cleanupMessageHandler()
  }

  open() {
    if (RAILS_ENV === 'test') {
      return
    }

    this.addCalendlyStyles()

    app.Plugin.use('calendly', () => {
      this.setupMessageHandler()

      window.Calendly.initPopupWidget({
        url: this.appendGdprBannerParam()
      })
    })
  }

  addCalendlyStyles() {
    const link = document.createElement('link')
    link.href = 'https://assets.calendly.com/assets/external/widget.css'
    link.rel = 'stylesheet'
    link.type = 'text/css'
    document.body.appendChild(link)
  }

  setupMessageHandler() {
    if (window.TFX_CALENDLY_POPUP_MESSAGE_HANDLER) {
      window.removeEventListener('message', window.TFX_CALENDLY_POPUP_MESSAGE_HANDLER)
    }

    this.boundHandler = this.handleMessage.bind(this)
    window.addEventListener('message', this.boundHandler)

    window.TFX_CALENDLY_POPUP_MESSAGE_HANDLER = this.boundHandler
  }

  cleanupMessageHandler() {
    if (window.TFX_CALENDLY_POPUP_MESSAGE_HANDLER === this.boundHandler) {
      window.TFX_CALENDLY_POPUP_MESSAGE_HANDLER = null
    }
    window.removeEventListener('message', this.boundHandler)
  }

  appendGdprBannerParam() {
    const url = new URL(this.eventUrlValue)
    url.searchParams.append('hide_gdpr_banner', '1')
    return url.toString()
  }

  handleMessage(e) {
    if (e.origin !== 'https://calendly.com' || !e.data.event || !e.data.event.startsWith('calendly.')) {
      return
    }

    if (e.data.event === 'calendly.event_type_viewed') {
      window.tfxEvent('discovery_call', {entry_point: this.contextValue, step: 'shown'})
    } else if (e.data.event === 'calendly.event_scheduled') {
      const eventId = e.data.payload.event.uri.split('/').pop()

      window.tfxEvent('discovery_call', {
        entry_point: this.contextValue,
        step: 'scheduled',
        event_id: eventId
      })

      Http.post(`//${APP_HOST}/discovery_calls/client/booking`, {
        form: {
          event_id: eventId,
          context: this.contextValue
        }
      })
    }
  }
}
